import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import OnboardingPlannerViewSectionHeader
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Components/OnboardingPlannerViewSectionHeader';
import { FDBox } from '@facet-wealth/design';
import Quiz from './Quiz';

function ViewSectionLayout() {
  const {
    resource,
  } = useMetaLayoutContext();
  const quizzes = resource.attr('sectionData')?.resources().list();

  return (
    <FDBox paddingX={3}>
      <OnboardingPlannerViewSectionHeader
        title={resource.attr('title')}
      />
      {quizzes.map((quiz) => <Quiz key={quiz.id()} quiz={quiz} />)}
    </FDBox>
  );
}

export default ViewSectionLayout;
